import React from "react";
import { Sparkles } from "lucide-react";

/**
 * "Generate overview" — fills the Overview tab's four fields (About the Book,
 * Who Should Read It, Actionable Insights, Questions Worth Asking) from the
 * "Overview generation" task in AI Settings.
 *
 * English only: English is the source the other languages are translated from
 * on save, so generating in another language would be overwritten by the next
 * translation anyway.
 */
const GenerateOverviewButton = ({ bookId, selectedLang, busy, onGenerate }) => {
  if (selectedLang !== "en") {
    return <small className="text-muted">Switch to English to generate the overview with AI.</small>;
  }
  return (
    <button
      type="button"
      className="btn btn-sm btn-outline-secondary"
      onClick={() => onGenerate(bookId)}
      disabled={busy || !bookId}
      title={bookId ? "Uses the Overview generation settings in AI Settings" : "Pick the book first"}
    >
      {busy ? (
        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
      ) : (
        <Sparkles size={14} className="me-1" />
      )}
      {busy ? "Generating overview…" : "Generate overview"}
    </button>
  );
};

export default GenerateOverviewButton;
